import {ROUTES_PATH} from './routes-path.enum';

export type LicenseType = 'urlLibraryLicense';

export interface ModuleInterface {
  title: string;
  icon: string;
  path: ROUTES_PATH;
  relatedRoutes?: ROUTES_PATH[];
  requires?: LicenseType[];
}

export const MODULES: ModuleInterface[] = [
  {
    title: 'SIDEBAR.DASHBOARD',
    icon: 'sidenav:home',
    path: ROUTES_PATH.DASHBOARD
  },
  {
    title: 'SIDEBAR.DIAGRAMS',
    icon: 'sidenav:processes',
    path: ROUTES_PATH.MAPS
  },
  {
    title: 'SIDEBAR.REQUIREMENTS',
    icon: 'sidenav:changes',
    path: ROUTES_PATH.CHANGES,
    relatedRoutes: [ROUTES_PATH.REQUIREMENTS, ROUTES_PATH.STORIES, ROUTES_PATH.FEEDBACKS]
  },
  {
    title: 'SIDEBAR.METADATA_LABEL',
    icon: 'sidenav:external-orgs',
    path: ROUTES_PATH.SF_ORGS,
    relatedRoutes: [ROUTES_PATH.REFERENCE_MODEL, ROUTES_PATH.SF_ORGS]
  },
  {
    title: 'SIDEBAR.URL_LIBRARY',
    icon: 'sidenav:url-library',
    path: ROUTES_PATH.URL_LIBRARY,
    requires: ['urlLibraryLicense']
  },
  {
    title: 'SIDEBAR.RELEASES',
    icon: 'sidenav:releases',
    path: ROUTES_PATH.RELEASES
  }
];
